<template>
  <div class="header">
    <div class="nav">
        <div class="nav_logo">
          <router-link to="/partyIndex">
            <img src="./img/logo.png" alt="nav_logo">
          </router-link>
        </div>
        <div class="nav_right">
          <el-menu :default-active="activeIndex" class="menu" mode="horizontal" @select="handleSelect" active-text-color="#e10062">
            <el-menu-item index="1"><router-link to="/partyIndex">首页</router-link></el-menu-item>
            <el-menu-item index="2">
              <router-link to="/introduce?m=2">
                党委介绍
              </router-link>
            </el-menu-item>
            <el-menu-item index="3">
              <router-link to="/articleList?m=3&list=1">
                党建发布
              </router-link>
            </el-menu-item>
            <el-menu-item index="4">
              <router-link to="/articleList?m=4&list=2">
                通知公告
              </router-link>
            </el-menu-item>
            <el-menu-item index="5">
              <router-link to="/articleList?m=5&list=3">
                网上党校
              </router-link>
            </el-menu-item>
            <el-menu-item index="6">
              <router-link to="/articleList?m=6&list=4">
                时政要闻
              </router-link>
            </el-menu-item>
            <el-menu-item index="7">
              <router-link to="/articleList?m=7&list=5">
                党建掠影
              </router-link>
            </el-menu-item>
          </el-menu>
        </div>
    </div>
  </div>
</template>

<script>
import common from '../../../static/js/common.js'
export default {
  name: 'Header',
  props:{
    menu:''
  },
  data () {
    return {
      active:1,
      activeIndex: '1'  
    }
  },
  methods:{
    handleSelect(key, keyPath) {  //选择栏目
      this.activeIndex=key;
    }
  },
  watch: { //路由检测
    '$route' (to, from) {
      this.activeIndex=(parseInt(to.query.list)+2).toString();
    }
  },
  created (){
    var list = common.getUrlParam('list'); 
    var m = common.getUrlParam('m')||'1';
    this.activeIndex=m;
  }
}
</script>

<style scoped>
  .header {width:100%;height:60px;background: #fff;}
  .header .nav{width:1200px;margin:0 auto;overflow: hidden;}
  .header .nav .nav_logo{float:left;width:303px;height:60px;}
  .header .nav .nav_logo img{width:90%;margin-top:5px;}
  .nav_right{float:right;}
  .menu li i{display:none;}
  .nav_right ul,.nav_right ul li{float:left;list-style-type: none;font-weight: 600;color:#333;}
  .nav_right ul li a{text-decoration:none;font-size:14px;width:80px;text-align:center;display: inline-block;color:#333;}
  .nav_right .el-menu--horizontal>.el-menu-item.is-active{border-bottom:4px solid #F51F1F;}
  .nav_right .el-menu--horizontal{border-bottom:none;}
  .nav_right .el-menu--horizontal>.el-menu-item{height:60px;line-height:60px;}
</style>



// WEBPACK FOOTER //
// src/components/party/VueHeader.vue